const TermsOfUse = () => {
  return (
    <div className="bg-gray-100 py-10 px-4">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-xl p-8">

        <h1 className="text-3xl font-bold text-center text-blue-900 mb-4">
          Terms of Use
        </h1>

        <p className="text-center text-gray-500 mb-8">
          <strong>Last Updated:</strong> March 2026
        </p>

        <p className="text-gray-700 mb-6">
          Welcome to <strong>Online Quran and Islamic Institute</strong>. By
          accessing our website or enrolling in our online Quran classes, you
          agree to comply with and be bound by the following Terms of Use.
          Please read these terms carefully before using our services.
        </p>

        {/* Section 1 */}
        <h2 className="text-xl font-semibold text-gray-800 mt-6 mb-3">
          1. Acceptance of Terms
        </h2>

        <p className="text-gray-700">
          By accessing our website or registering for our classes, you confirm
          that you accept these Terms of Use and agree to comply with them. If
          you do not agree with any part of these terms, please do not use our
          services.
        </p>

        {/* Section 2 */}
        <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">
          2. Our Services
        </h2>

        <p className="text-gray-700 mb-3">
          Online Quran and Islamic Institute provides online educational
          services including:
        </p>

        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>Online Quran reading and memorization classes.</li>
          <li>Islamic studies and Tajweed lessons.</li>
          <li>Personalized one-on-one or group classes.</li>
        </ul>

        {/* Section 3 */}
        <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">
          3. Student Responsibilities
        </h2>

        <ul className="list-disc pl-6 text-gray-700 space-y-2">
          <li>Provide accurate information during registration.</li>
          <li>Attend scheduled classes on time.</li>
          <li>Maintain respectful behavior during online sessions.</li>
          <li>Ensure a stable internet connection for classes.</li>
        </ul>

        {/* Section 4 */}
        <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">
          4. Payments and Fees
        </h2>

        <p className="text-gray-700">
          Tuition fees must be paid according to the agreed schedule. Failure
          to make payments may result in suspension of classes until payment is
          completed.
        </p>

        {/* Section 5 */}
        <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">
          5. Intellectual Property
        </h2>

        <p className="text-gray-700">
          All course materials, lesson content, and educational resources
          provided by Online Quran and Islamic Institute are the intellectual
          property of the institute and may not be reproduced, distributed, or
          used for commercial purposes without permission.
        </p>

        {/* Section 6 */}
        <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">
          6. Class Conduct
        </h2>

        <p className="text-gray-700">
          Students are expected to behave respectfully during classes. Any form
          of inappropriate behavior, harassment, or disruption may result in
          termination of services.
        </p>

        {/* Section 7 */}
        <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">
          7. Limitation of Liability
        </h2>

        <p className="text-gray-700">
          Online Quran and Islamic Institute will not be held responsible for
          technical issues such as internet disruptions, platform outages, or
          other circumstances beyond our control.
        </p>

        {/* Section 8 */}
        <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">
          8. Changes to Terms
        </h2>

        <p className="text-gray-700">
          We reserve the right to update or modify these Terms of Use at any
          time. Updated versions will be posted on our website with the updated
          revision date.
        </p>

        {/* Section 9 */}
        <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-3">
          9. Contact Us
        </h2>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 text-gray-700">
          <p>
            If you have questions about these Terms of Use, please contact us:
          </p>

          <p className="mt-2">
            <strong>Email:</strong> ceo@onlinequranandislamicinstitue.com
          </p>

          <p>
            <strong>WhatsApp/Phone:</strong> +92 339 155 2155
          </p>

          <p>
            <strong>Address:</strong> 3rd floor, kiyani plaza murree road,
            Shamsabad, Rawalpindi, Pakistan
          </p>
        </div>

        <p className="text-center text-gray-400 mt-10 text-sm">
          © 2026 Online Quran and Islamic Institute — All Rights Reserved
        </p>

      </div>
    </div>
  );
};

export default TermsOfUse;